var render = function render() {
  var _vm$personalConfig, _vm$personalConfig2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "700px",
      "mask-closable": false,
      "closable": false
    },
    on: {
      "on-visible-change": _vm.onClose
    },
    model: {
      value: _vm.protection,
      callback: function ($$v) {
        _vm.protection = $$v;
      },
      expression: "protection"
    }
  }, [_vm.flag && _vm.protection ? [_c('div', [_c('div', {
    staticClass: "step-box"
  }, [_c('Steps', {
    attrs: {
      "current": _vm.currentStep
    }
  }, _vm._l(_vm.removeStepList, function (item, index) {
    return _c('Step', {
      key: index,
      attrs: {
        "title": _vm.isMobile ? null : item.title,
        "content": item.content
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep == 0,
      expression: "currentStep == 0"
    }]
  }, [_c('div', [_c('p', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm$personalConfig = _vm.personalConfig) === null || _vm$personalConfig === void 0 ? void 0 : _vm$personalConfig.issuer))]), _c('span', [_vm._v(_vm._s(`（${_vm.compUtedUnitCode}）`))])]), _vm.protection ? _c('SafetyCodeInput', {
    ref: "validForm",
    on: {
      "validate": _vm.nextStep
    }
  }) : _vm._e()], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep == 1,
      expression: "currentStep == 1"
    }]
  }, [_c('Alert', {
    attrs: {
      "type": "success",
      "show-icon": ""
    }
  }, [_vm._v(` ${$t("hx53z14", "解绑成功")} `), _c('span', {
    attrs: {
      "slot": "desc"
    },
    slot: "desc"
  }, [_vm._v(`${$t("42to0qa", "您已经成功解绑MFA")} `)])]), _c('div', {
    staticClass: "email"
  }, [_c('span', {
    on: {
      "click": _vm.backToIndex
    }
  }, [_vm._v($t("5gssfj5", "返回工作台"))])])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep < 1,
      expression: "currentStep < 1"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v($t("btdio3", "下一步"))])], 1)] : _vm._e(), !_vm.flag && _vm.protection ? [_c('div', [_c('div', {
    staticClass: "step-box"
  }, [_c('Steps', {
    attrs: {
      "current": _vm.currentStep
    }
  }, _vm._l(_vm.bindStepList, function (item, index) {
    return _c('Step', {
      key: index,
      attrs: {
        "title": _vm.isMobile ? null : item.title,
        "content": item.content
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep == 0,
      expression: "currentStep == 0"
    }],
    staticClass: "form-box"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "400px"
    }
  }, [_c('Form', {
    attrs: {
      "label-position": "top",
      "label-colon": ""
    }
  }, [_c('FormItem', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "required": "",
      "rules": {
        required: true,
        message: $t("zapn0u8", "请输入正确安全码"),
        trigger: 'blur'
      },
      "label": $t("k2pbsb4", "验证方式")
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": function ($event) {
        return _vm.changeLoginType($event);
      }
    },
    model: {
      value: _vm.accountType,
      callback: function ($$v) {
        _vm.accountType = $$v;
      },
      expression: "accountType"
    }
  }, [_vm.userInfo.mobile !== '' ? _c('Radio', {
    attrs: {
      "label": "MOBILE"
    }
  }, [_c('span', [_vm._v($t("ewbd43", "手机号"))])]) : _vm._e(), _vm.userInfo.email !== '' ? _c('Radio', {
    attrs: {
      "label": "EMAIL"
    }
  }, [_c('span', [_vm._v($t("padf2", "邮箱"))])]) : _vm._e()], 1)], 1)], 1), _c('SendMessage', {
    ref: "sendMessage",
    staticClass: "send-message",
    attrs: {
      "accountType": _vm.accountType,
      "showText": true,
      "mode": "FORGET_PASSWORD",
      "exist": true
    },
    on: {
      "onEnter": _vm.onEnter
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('Poptip', {
    attrs: {
      "trigger": "hover",
      "width": "300"
    }
  }, [_c('div', {
    staticClass: "tip",
    staticStyle: {
      "margin-top": "20px",
      "color": "#1677ff",
      "cursor": "pointer",
      "font-size": "13px"
    }
  }, [_vm._v(` ${$t("xcml07", "收不到验证码？")} `)]), _c('div', {
    staticClass: "api",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l(_vm.currentTipList, function (item) {
    return _c('div', {
      key: item,
      staticStyle: {
        "word-break": "break-all",
        "white-space": "normal",
        "overflow": "hidden"
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0)])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep == 1,
      expression: "currentStep == 1"
    }]
  }, [_c('Alert', {
    attrs: {
      "show-icon": ""
    }
  }, [_c('template', {
    slot: "desc"
  }, [_c('p', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(` ${$t("hxe48p1v", "安卓版：Google Authenticator，Microsoft Authenticator，阿里云App虚拟MFA，CKEY令牌")} `)]), _c('p', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(` ${$t("8e0ik41s", "iOS版：Google Authenticator，Microsoft Authenticator，阿里云 App 虚拟 MFA")} `)]), _c('p', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(` ${$t("typba14", "微信小程序：MinaOTP，MFA Authentication，CKEY 令牌")} `)])])], 2), _c('Alert', {
    staticClass: "download-alert",
    attrs: {
      "show-icon": ""
    }
  }, [_c('template', {
    slot: "desc"
  }, [_vm._v(`${$t("xoxhd0x", "下载完成后直接进入下一步，进入绑定页面（如已经下载直接点击下一步）")} `)])], 2)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep == 2,
      expression: "currentStep == 2"
    }]
  }, [_c('Alert', {
    attrs: {
      "show-icon": ""
    }
  }, [_c('template', {
    slot: "desc"
  }, [_c('p', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(` ${$t("hxe48p1v", "安卓版：Google Authenticator，Microsoft Authenticator，阿里云App虚拟MFA，CKEY令牌")} `)]), _c('p', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(` ${$t("8e0ik41s", "iOS版：Google Authenticator，Microsoft Authenticator，阿里云 App 虚拟 MFA")} `)]), _c('p', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(` ${$t("typba14", "微信小程序：MinaOTP，MFA Authentication，CKEY 令牌")} `)])])], 2), _c('div', {
    staticClass: "qrcode-container"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "width": "200px",
      "height": "200px",
      "background-color": "#ffffff"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "width": "200px",
      "height": "200px",
      "visibility": "qrcodeDataUrl ? 'visible' : 'hidden'"
    },
    attrs: {
      "src": _vm.qrcodeDataUrl,
      "alt": "QR Code"
    }
  }), !_vm.qrcodeDataUrl ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" Loading QR Code... ")]) : _vm._e()]), _c('div', {
    staticStyle: {
      "padding": "24px 5px",
      "flex": "1"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm$personalConfig2 = _vm.personalConfig) === null || _vm$personalConfig2 === void 0 ? void 0 : _vm$personalConfig2.issuer))]), _c('span', [_vm._v(_vm._s(`（${_vm.compUtedUnitCode}）`))])]), _c('SafetyCodeInput', {
    ref: "validForm",
    attrs: {
      "title": [$t("7r6u6ar", "使用以上任一身份验证器APP扫描二维码，获取6位安全码")],
      "showIcon": false
    },
    on: {
      "validate": _vm.nextStep
    }
  })], 1)])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep == 3,
      expression: "currentStep == 3"
    }]
  }, [_c('Alert', {
    attrs: {
      "type": "success",
      "show-icon": ""
    }
  }, [_vm._v(` ${$t("gdpuew4", "绑定成功")} `), _c('template', {
    slot: "desc"
  }, [_c('p', [_vm._v($t("rrjnp3b", "您已经成功绑定MFA。"))]), _c('p', [_vm._v(` ${$t("5lrevq1k", "请勿随意删除卸载身份验证器APP，否则会导致无法进行MFA校验登录。如需要卸载APP或更换手机，请先解绑MFA。")} `)])])], 2), _c('div', {
    staticClass: "email"
  }, [_c('span', {
    on: {
      "click": _vm.backToIndex
    }
  }, [_vm._v($t("5gssfj5", "返回工作台"))])])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep < 3,
      expression: "currentStep < 3"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v($t("btdio3", "下一步"))])], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };